export enum CartStatuses {
  Pending = 'Pending',
  CheckedOut = 'CheckedOut',
  PartiallyPaid = 'PartiallyPaid',
  CheckoutFailed = 'CheckoutFailed'
}
